export default __webpack_public_path__ + "static/home-4-hero-bg-a2bf867ea43381f97e65fe8a1330533a.jpg";